var React = require('react');

function M3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"M3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"51.2 41.62 45.13 24.85 36.14 0 0 81.06 33.06 82.32 66.11 83.58 66.4 83.59 51.2 41.62","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"95.49 83.08 67.36 0.45 48.04 33.23 58.1 82.17 95.49 83.08","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

M3.defaultProps = {"viewBox":"0 0 95.49 83.59"};

module.exports = M3;

M3.default = M3;
